import { fork, all } from 'redux-saga/effects';

import actionDropdownSagas from './actionDropdownSagas';
import headerActionsSagas from './headerActionsSagas';
import tableActionsSagas from './tableActionsSagas';
import pageContainersSagas from './pageContainersSagas';
import surveyEditorSagas from './surveyEditorSagas';

export default function* rootSaga() {
  yield all([
    fork(actionDropdownSagas),
    fork(headerActionsSagas),
    fork(tableActionsSagas),
    fork(pageContainersSagas),
    fork(surveyEditorSagas),
  ]);
}
